
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 36 36"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "输入文字"
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "图像_3",
        "data-name": "图像 3",
        "style": "isolation:isolate"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "图像_3-2",
            "data-name": "图像 3"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "width": "36",
                "height": "36",
                "rx": "3",
                "ry": "3",
                "style": "fill:#5397ff"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "图像_11_复制",
        "data-name": "图像 11_复制",
        "style": "isolation:isolate"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "图像_11",
            "data-name": "图像 11"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "d": "M27,8H10A1,1,0,0,0,9,9v2a1,1,0,1,0,2,0h6V25H15.5a1.5,1.5,0,0,0,0,3h6a1.5,1.5,0,0,0,0-3H20V11h6a1,1,0,1,0,2,0V9A1,1,0,0,0,27,8Z",
                "style": "fill:#fafcff;fill-rule:evenodd"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  